import React from 'react';
import TitleDecoration from "../elements/TitleDecoration";
import { classNames } from "../../helpers/classNames";

const PricingElements = () => {
  return (
    <>
      <div className="bg-doodle-pattern absolute bottom-0 left-0 w-full h-full" />
      <div className="absolute bottom-0 left-0">
        <div className="animate-float">
          <div className="bg-gradient-to-tr from-indigo to-purple absolute bottom-80 -left-20 w-52 aspect-square rounded-full" />
        </div>
        <div className="animate-float-reverse">
          <div className="bg-gradient-to-tr from-red to-orange absolute bottom-44 left-8 w-32 aspect-square rounded-full" />
        </div>
        <div className="animate-float">
          <div className="bg-gradient-to-tr from-green to-yellow absolute bottom-20 -left-5 w-20 aspect-square rounded-full" />
        </div>
      </div>
    </>
  );
};

const HomePricing = () => {
  const features = [
    { _id: 1, name: '8.5" x 11" Pages', icon: "fa-regular fa-pen-ruler", color:"text-purple"},
    { _id: 2, name: 'Saddle Stitched', icon: "fa-regular fa-book-open", color:"text-red"},
    { _id: 3, name: 'Ships in 3-5 days', icon: "fa-regular fa-truck-fast", color:"text-orange"},
    { _id: 4, name: 'Multiple Styles', icon: "fa-regular fa-palette", color:"text-green"},
  ]

  return (
    <>
      <section className="relative py-40 overflow-hidden bg-light-blue/10 z-[1] flex items-center">
        <PricingElements />
        <div className="relative w-full px-4 sm:px-0 sm:max-w-xl md:max-w-2xl lg:max-w-4xl xl:max-w-6xl 2xl:max-w-7xl 3xl:max-w-9xl mx-auto">
          <div className="grid grid-cols-2 gap-10 items-center">
            <div className="relative">
              <div className="space-y-6 pr-20 relative max-w-lg text-right ml-auto">
                <div className="relative space-y-2">
                  <h2 className="font-BubblegumSans text-5xl">Simple, Transparent Pricing</h2>
                  <TitleDecoration classes={"!justify-end"} />
                </div>
                <div className="text-xl">Create beautiful, personalized coloring books at an affordable price</div>
              </div>
            </div>
            <div className="relative">
              <div className="bg-white shadow-lg rounded-3xl overflow-hidden max-w-lg animate-float">
                <div className="py-10 px-12 bg-gradient-to-tr from-red to-blue text-white">
                  <h2 className="font-BubblegumSans text-3xl font-medium">Custom Coloring Book</h2>
                  <div className="text-6xl font-medium">$19.99 <small className="text-3xl">per book</small></div>
                  <div className="text-base text-light">Up to 20 pages of personalized coloring fun</div>
                </div>
                <div className="py-10 px-12 space-y-8">
                  <div className="text-lg text-black pricing-description">
                    <ul>
                      <li>Transform your photos into custom coloring pages</li>
                      <li>Choose your preferred coloring style</li>
                      <li>Add personalized details and special requests</li>
                      <li>High-quality printing on premium paper</li>
                      <li>Durable saddle stitched binding allows pages to lay flat</li>
                      <li>Digital preview before printing</li>
                    </ul>
                  </div>
                  {features?.length > 0 && (
                    <div className="grid grid-cols-2 gap-x-4 gap-y-2">
                      {features?.map((item, index) => (
                        <div key={index} className="text-base flex items-center gap-2"><i className={classNames("text-xl", item?.icon, item?.color)}></i> {item?.name}</div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HomePricing;